import React from 'react';
import style from "./index.module.css";
import {Table} from "antd";
import {useNavigate} from 'react-router-dom';

const NoticeModule = ({type}: { type: string }) => {
    const navigate = useNavigate();
    const columns: any[] = [
        {
            title: '名称',
            dataIndex: 'name',
            key: 'name',
            width: '80%'
        },
        {
            title: '时间',
            dataIndex: 'time',
            key: 'time',
            width: '20%'
        },
    ];

    const noticeData = [
        {
            id: 207,
            name: "国家认监委关于增加移动电源等强制性产品认证依据标准并发布新版实施规则的公告",
            time: "2026-05-31",
        },
        {
            id: 208,
            name: "国家认监委关于发布产品碳足迹标识认证通用实施规则（试行）的公告",
            time: "2025-03-17",
        },
        {
            id: 11,
            name: "全市首个行业碳基础数据库顺利验收投用",
            time: "2024-11-01",
        },
        {
            id: 12,
            name: "全市国企首个双碳领域认证资质",
            time: "2024-10-14",
        },
        {
            id: 6,
            name: "市场监管总局关于发布 《温室气体自愿减排项目审定与减排量核查实施规则》的公告",
            time: "2023-12-27",
        },
        {
            id: 7,
            name: "碳达峰碳中和质量认证体系建设工作座谈会在京召开",
            time: "2023-12-22",
        },
        {
            id: 13,
            name: "市产业集团赴京洽谈“双碳”认证试点工作推进会",
            time: "2023-08-11",
        },
    ];

    const industryData = [
        {
            id: 209,
            name: "认证认可检验检测：创新与发展新质生产力第三届认证认可大会在广州举办",
            time: "2026-06-09",
        },
        {
            id: 101,
            name: "国家认监委关于开展电动自行车用锂离子蓄电池、电动自行车用充电器、可燃气体探测报警产品强制性产品认证实施机构指定工作的公告",
            time: "2024-08-01",
        },
        {
            id: 102,
            name: "助推内外贸一体化发展 浙江累计发展“三同”产品超2000种",
            time: "2024-07-19",
        },
    ];

    const lawData = [
        {
            id: 201,
            name: "《认证证书和认证标志管理办法》",
            time: "2018-10-08",
        },
        {
            id: 206,
            name: "《质量管理体系认证规则》",
            time: "2019-10-11",
        },
        {
            id: 203,
            name: "《中华人民共和国认证认可条例》（2020年修订版）",
            time: "2020-12-01",
        },
        {
            id: 204,
            name: "《中华人民共和国产品质量法》",
            time: "2018-11-15",
        },
        {
            id: 205,
            name: "《中华人民共和国计量法》",
            time: "2018-10-20",
        },
    ];


    const suspendRevokeData:any[] = [
    ];

    return (
        <div>
            <div className={style.articleTitle}>
                {type === 'c1' ? '通知公告'
                    : type === 'c2' ? '行业动态'
                        : type === 'c3' ? '政策法规'
                            : type === 'c4' ? '暂停撤销公告'
                                : ""}
            </div>

            <div>
                <div style={{margin: "10px 5%", width: "90%"}}>
                    <Table style={{
                        backgroundColor: '#fff',  // 设置表格背景颜色
                        color: '#333',                // 设置字体颜色
                    }} size="small" rowClassName={style.row} showHeader={false} columns={columns}
                           dataSource={type === 'c1' ? noticeData
                               : type === 'c2' ? industryData
                                   : type === 'c3' ? lawData
                                       : type === 'c4' ? suspendRevokeData
                                           : []}
                           onRow={(record, rowIndex) => {
                               // 这里返回一个对象，包含行的事件处理程序
                               return {
                                   onClick: () => {
                                       navigate('/information', {state: {subPath: type, articleId: record?.id}})
                                   },
                               };
                           }}/>
                </div>

            </div>
        </div>
    );
};

export default NoticeModule;